import { render, staticRenderFns } from "./GeneralAfter.vue?vue&type=template&id=3ba2334a&scoped=true"
import script from "./GeneralAfter.vue?vue&type=script&lang=ts"
export * from "./GeneralAfter.vue?vue&type=script&lang=ts"
import style0 from "./GeneralAfter.vue?vue&type=style&index=0&id=3ba2334a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba2334a",
  null
  
)

export default component.exports